import React, { useEffect, useRef, useState } from 'react';
/** lib **/
import { SERVICE_NAME } from '../../const';
import { SupporterVoiceList } from 'lib/supporter-voice';
/** components **/
import { FadeUp, ParallaxItem } from 'components/organisms';
/** styles,images **/
import s from '../../styles/organisms/supporter-voice.module.scss';
import BgLogo from 'assets/images/bg-logo.svg';
import Pwan from 'assets/images/pwan.png';
import classNames from 'classnames';

export const SupporterVoice: React.FC = () => {
  const reversedSupporterVoiceList = [...SupporterVoiceList].reverse();
  const innerRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (innerRef.current) {
        const rect = innerRef.current.getBoundingClientRect();
        const visible = rect.top <= 0 && rect.bottom > 0;
        setIsVisible(visible);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // 初期チェック

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className={s.supporterVoiceWrapper}>
      <FadeUp>
        <div className={s.inner} ref={innerRef}>
          <a
            href="https://mecgroup.app.box.com/f/c6e816b951d64ea39a306c44733ed4d5"
            target="_blank"
            rel="noopener noreferrer"
            className={classNames(s.notice, { [s.visible]: isVisible })}
          >
            <p>お写真投稿はこちら！</p>
            <img src={Pwan} alt="ピーワン" />
          </a>
          {reversedSupporterVoiceList.map((item, index) => (
            <div className={s.item} key={index}>
              <div className={s.image}>
                <img src={require(`assets/images/${item.image}`)} alt={item.spec} />
              </div>
              <div className={s.text}>
                <p className={s.spec}>{item.spec}</p>
                <p>{item.text}</p>
              </div>
            </div>
          ))}
        </div>
      </FadeUp>

      <ParallaxItem className={s.parallaxBg}>
        <img src={BgLogo} alt={SERVICE_NAME} />
      </ParallaxItem>
    </div>
  );
};
